import { IBook } from '@partiu/api/types';

export function saveBookProgress(book: IBook, progress: string = '0', position: string = '0') {
  localStorage.setItem(`current-book`, JSON.stringify(book));
  localStorage.setItem(`current-book-progress`, progress);
  localStorage.setItem(`${book.id}-position`, position);
}

export function getBookPosition(bookId: number) {
  return parseInt(localStorage.getItem(`${bookId}-position`) || '0');
}
